import React, {
  useState
} from 'react';

import {
  ChevronRight,
  Monitor,
  Power,
  Star,
  Zap
} from 'lucide-react';

import {
  useRealtime
} from '../../contexts/RealtimeContext';

import {
  PCControlModal
} from './PCControlModal';


export const PCControlHomeCard:
  React.FC =
() => {

  const [
    open,
    setOpen
  ] =
    useState(
      false
    );


  const {
    device,
    deviceStatus,
    latencyMs
  } =
    useRealtime();


  const online =
    deviceStatus ===
      'online';


  return (
    <>

      <button
        type="button"
        onClick={
          () =>
            setOpen(
              true
            )
        }
        className="
          group
          relative
          w-full
          mb-5
          overflow-hidden
          rounded-[20px]
          border
          border-white/[0.08]
          bg-slate-900/55
          shadow-[0_22px_70px_rgba(2,6,23,0.28)]
          backdrop-blur-2xl
          text-left
          transition
          hover:border-indigo-400/20
          hover:bg-slate-900/68
        "
      >

        <div
          className="
            absolute
            inset-0
            pointer-events-none
            bg-gradient-to-r
            from-indigo-500/[0.07]
            via-transparent
            to-cyan-400/[0.025]
          "
        />


        <div
          className="
            relative
            px-4 sm:px-5
            py-4
            flex
            items-center
            gap-4
          "
        >

          <div
            className="
              shrink-0
              w-11 h-11
              rounded-xl
              border
              border-indigo-400/15
              bg-indigo-400/10
              flex
              items-center
              justify-center
            "
          >
            <Monitor
              className="
                w-5 h-5
                text-indigo-300
              "
            />
          </div>


          <div
            className="
              flex-1
              min-w-0
            "
          >

            <div
              className="
                flex
                items-center
                gap-2
              "
            >

              <span
                className="
                  text-sm
                  font-semibold
                  text-slate-100
                "
              >
                PC Control
              </span>


              <span
                className={
                  `
                    w-1.5 h-1.5
                    rounded-full
                    ${
                      online
                        ? 'bg-emerald-400'
                        : 'bg-rose-400'
                    }
                  `
                }
              />

            </div>


            <div
              className="
                mt-1
                text-[11px]
                text-slate-500
                truncate
              "
            >
              {device?.name ||
                'Windows Host'}

              {online
                ? (
                    latencyMs
                      ? ` · ${latencyMs} ms`
                      : ' · Online'
                  )
                : ' · Offline'}
            </div>


            <div
              className="
                mt-2
                flex
                items-center
                gap-3
                text-[10px]
                text-slate-600
              "
            >

              <span
                className="
                  flex
                  items-center
                  gap-1
                "
              >
                <Star
                  className="
                    w-3 h-3
                  "
                />
                Favourites
              </span>

              <span
                className="
                  flex
                  items-center
                  gap-1
                "
              >
                <Zap
                  className="
                    w-3 h-3
                  "
                />
                Apps
              </span>

              <span
                className="
                  flex
                  items-center
                  gap-1
                "
              >
                <Power
                  className="
                    w-3 h-3
                  "
                />
                Power
              </span>

            </div>

          </div>


          <ChevronRight
            className="
              shrink-0
              w-4 h-4
              text-slate-600
              group-hover:text-indigo-300
              group-hover:translate-x-0.5
              transition
            "
          />

        </div>

      </button>


      <PCControlModal
        isOpen={
          open
        }
        onClose={
          () =>
            setOpen(
              false
            )
        }
      />

    </>
  );
};